import sanitizeObject from '@htmniseko/htm-helpers/misc/sanitizeObject';
import { getMessage } from 'utils/errors';

let requestIdCounter = 0;

export default function clientMiddleware(client) {
  return ({ dispatch, getState }) => next => action => {
    if (typeof action === 'function') {
      return action(dispatch, getState);
    }

    const sanitizedAction = sanitizeObject(action);
    if (typeof action !== 'object') {
      return action;
    }

    const { promise, ...rest } = sanitizedAction;
    if (!promise) {
      return next(sanitizedAction);
    }

    const [REQUEST, SUCCESS, FAILURE] = action.types;

    // Unique id per dispatch so concurrent same-type requests don't share a
    // timer key in appMiddleware — each request gets its own displayLoader timer.
    requestIdCounter += 1;
    const requestId = `${REQUEST}_${requestIdCounter}`;
    const enrichedRest = { ...rest, meta: { ...(rest.meta || {}), requestId } };

    next({ ...enrichedRest, type: REQUEST });

    const { auth } = getState();

    // Set the session access token in the API request, if available.
    client.setToken(auth ? auth.token : null);

    const actionPromise = promise(client);
    actionPromise.then(
      result => next({ ...enrichedRest, result, type: SUCCESS }),
      error => next({ ...enrichedRest, error: getMessage(error), type: FAILURE })
    ).catch(error => {
      console.error('MIDDLEWARE ERROR:', error);
      next({ ...enrichedRest, error: getMessage(error), type: FAILURE });
    });

    return actionPromise;
  };
}
